import React from 'react';
import './ImageShowcase.css';
// Import the image directly using the relative path
import mumbaiPawImage from '../assets/IMG_2597.jpg';

function ImageShowcase() {
  return (
    <section className="image-showcase">
      <h2>Mumbai Pav Showcase</h2>
      <div className="showcase-container">
        <div className="image-wrapper">
          <img 
            src={mumbaiPawImage}
            alt="Freshly baked Mumbai Pav dinner rolls arranged in a ceramic baking dish" 
            className="showcase-image"
          />
        </div>
        <div className="image-caption">
          <p>Freshly baked Mumbai Pav - golden brown and ready to serve!</p>
        </div>
      </div>
    </section>
  );
}

export default ImageShowcase;